/**
 * @param {Object} props
 * @param {React.CSSProperties} [props.style]
 * @returns {React.JSX.Element}
 */
export function ArrowIcon({ style }) {
  return (
    <svg style={style} width="13.004" height="24" fill="none" viewBox="0 0 13.004 24">
      <path
        d="m1.1236 24 11.88-12-11.88-12-1.1236 1.0298 10.853 10.97-10.853 10.97 0.222 0.2032z"
        fill="#fff"
        clipRule="evenodd"
        fillRule="evenodd"
      />
    </svg>
  );
}
